import React, { useEffect } from "react";
import { useSetState } from "utils/functions.utils";
import OutsideClickHandler from "react-outside-click-handler";


const OutsideClickHandlerComponent = (props) => {
  // Reference

  // Redux

  // State
  const [state, setState] = useSetState({});

  //Hooks
  useEffect(() => {}, []);

  // Network req

  //Logic

  return (
    <OutsideClickHandler
      {...props}
    >
      {props.children}
    </OutsideClickHandler>
  );
};

export default OutsideClickHandlerComponent;
